module.exports = __webpack_public_path__ + "static/1_QUEEN-5862957460298b741d7494e8967cf816.png";